import React from "react";

interface DestinationImageProps {
  src: string;
  alt?: string;
  alignment?: "left" | "right";
  fromColor?: string;
  toColor?: string;
}

const DestinationImage: React.FC<DestinationImageProps> = ({
  src,
  alt,
  alignment = "right",
  fromColor = "from-blue-ea",
  toColor = "to-white",
}) => {
  return (
    <div
      className={`h-180 rounded-4xl bg-linear-to-t ${fromColor} ${toColor} flex-1  overflow-hidden flex items-center ${alignment === "right" ? "justify-end" : "justify-start"}`}
    >
      <div className="w-[90%] h-[90%]">
        <img
          src={src}
          alt={alt ?? "study-destination"}
          className={`w-full h-full rounded-2xl object-cover ${alignment === "right" ? "rounded-r-none" : "rounded-l-none"}`}
        />
      </div>
    </div>
  );
};

export default DestinationImage;
